var vueSlider = require('./vue2-slider')

module.exports = vueSlider


// WEBPACK FOOTER //
// ./src/components/sliderComponent/vue-slider/index.js